module.exports = __webpack_public_path__ + "static/media/winter_discovery_pack_dog_FR.d93f8b9d.png";